import React from 'react'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import type { HeadCells, OnSortChange } from './table.types'
import type { ISort } from '@homeviews/models'
import clsx from 'clsx'

interface EnhancedTableProps {
  classes: Record<string, string>
  cells: HeadCells
  onSortChange?: OnSortChange
  activeSort: ISort
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { classes, cells, onSortChange, activeSort } = props

  return (
    <TableHead>
      <TableRow>
        {cells.map((cell) => {
          const sortDirection =
            activeSort?.sort_direction === 'desc' ? 'asc' : 'desc'
          return (
            <TableCell
              key={cell.id}
              align={'left'}
              padding={cell.disablePadding ? 'none' : 'normal'}
              width={cell?.width ? cell.width : 'auto'}
              style={{
                width: cell.width || 'auto',
                maxWidth: cell.width || 'none',
              }}
              onClick={() => {
                if (!cell.sortable) {
                  return
                }
                onSortChange &&
                  onSortChange({
                    sort: cell.id,
                    sort_direction: sortDirection,
                  })
              }}
            >
              {cell.label}

              {!!cell.sortable && (
                <div
                  className={clsx(
                    'l-sortArrowWrapper',
                    classes.sortArrowWrapper,
                    activeSort?.sort === cell.id && `sort_${sortDirection}`,
                  )}
                >
                  <img
                    src="assets/icons/medium/arrow-down.svg"
                    alt="Sort arrow"
                  />
                </div>
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

export default EnhancedTableHead
